import { useEffect, useState } from 'react'
import { Checkbox, FormControlLabel } from '@mui/material'
import { useNotify, useRefresh } from 'react-admin'
import { updateVehicleAdjustmentValue } from '../../Utils/RestUtils'
import AdjustmentSelect from './AdjustmentSelect'
import PropTypes from 'prop-types'
import { useAdjustmentStatusContext } from '../../Utils/providers/AdjustmentStatusProvider'

const Adjustment = ({ adjustment, adjustmentSettings, onConfirmedChange }) => {
  const notify = useNotify()
  const refresh = useRefresh()
  const { refresh: refreshAdjustmentStatus, setAllowGetOffers } =
    useAdjustmentStatusContext()
  const [isUpdating, setIsUpdating] = useState(false)

  let adjType = adjustmentSettings.adjustmentType
  let adjValues = adjustmentSettings.adjustmentValues

  //Override of adjust display name
  let adjustName = adjustmentSettings.adjustmentName
  if (adjustName === 'Keys') {
    adjustName = 'Two Keys'
  } else if (adjustName === 'MOT Fault') {
    adjustName = 'MOT Failure'
  } else if (adjustName === 'Insurance') {
    adjustName = 'Insurance Write Off'
  }

  const currentValue = Array.isArray(adjValues)
    ? adjValues[adjustment.value]
    : [adjValues, 'negative', 'percentage']

  let componentType = adjType === 'GROUPED' ? 'SWITCH' : 'SELECT'

  const defaultCheckedValue =
    componentType === 'SWITCH' ? adjustment.value !== 0 : currentValue[0] !== 0

  const [checked, setChecked] = useState(defaultCheckedValue)
  const [confirmed, setConfirmed] = useState(adjustment.confirmed)
  const [selected, setSelected] = useState(adjustment.value)

  const handleChange = async (e) => {
    e.stopPropagation()

    try {
      setIsUpdating(true)
      setAllowGetOffers(false)
      let adjustmentValue

      if (componentType === 'SWITCH') {
        adjustmentValue = !checked ? 1 : 0
      }

      if (componentType === 'SELECT') {
        adjustmentValue = parseInt(e.target.value)
        e.target.classList.add('MuiButton-containedSuccess')
        e.target.classList.remove('MuiButton-containedError')
      }

      setSelected(adjustmentValue)
      setChecked(!checked)
      setConfirmed(true)
      onConfirmedChange?.(true)

      await updateVehicleAdjustmentValue(adjustment['@id'], adjustmentValue)
      refresh()
      await refreshAdjustmentStatus(
        adjustName === 'Showroom Condition' ? 'Damage Changed' : adjustName
      )
      localStorage.setItem('recalculate', 'true')
      window.dispatchEvent(new Event('storage'))

      // Also re-check damage list if "Showroom Condition" was changed
      if (adjustName === 'Showroom Condition') {
        window.dispatchEvent(new Event('checkVehicleDamage'))
      }
    } catch (error) {
      notify('Error updating value: ' + error, { type: 'error' })
    } finally {
      setIsUpdating(false)
    }
  }

  useEffect(() => {
    setChecked(
      componentType === 'SWITCH'
        ? adjustment.value !== 0
        : currentValue[0] !== 0
    )
    setConfirmed(adjustment.confirmed)
    setSelected(adjustment.value)
  }, [adjustment['@id'], adjustment.value, adjustment.confirmed])

  return componentType === 'SWITCH' ? (
    <FormControlLabel
      control={
        <Checkbox
          color={`${
            confirmed && checked
              ? 'success'
              : !confirmed && checked
              ? 'secondary'
              : 'error'
          }`}
          checked={checked}
          onClick={handleChange}
          inputProps={{ 'data-confirmed': confirmed }}
          disabled={isUpdating}
        />
      }
      label={adjustName}
      className="vehicle-adjustment__label"
    />
  ) : (
    <AdjustmentSelect
      adjustmentSettings={adjustmentSettings}
      selectedIndex={selected}
      confirmed={confirmed}
      onChange={handleChange}
      adjustName={adjustName}
      disabled={isUpdating}
    />
  )
}

Adjustment.propTypes = {
  adjustment: PropTypes.any,
  adjustmentSettings: PropTypes.shape({
    adjustmentValues: PropTypes.array,
    adjustmentType: PropTypes.string,
    adjustmentName: PropTypes.string,
  }),
  onConfirmedChange: PropTypes.func,
}

export default Adjustment
